export const Countries: {
  [key: string]: {
    name: string;
    dial_code: string;
    code: string;
    latitude: number;
    longitude: number;
    currency: string;
    flag: string;
    flag_unicode: string;
  }
} = {
  "AD": {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD",
    "latitude": 42.5,
    "longitude": 1.6,
    "currency": "EUR",
    "flag": "🇦🇩",
    "flag_unicode": "U+1F1E6 U+1F1E9"
  },
  "AE": {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE",
    "latitude": 24,
    "longitude": 54,
    "currency": "AED",
    "flag": "🇦🇪",
    "flag_unicode": "U+1F1E6 U+1F1EA"
  },
  "AF": {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF",
    "latitude": 33,
    "longitude": 65,
    "currency": "AFN",
    "flag": "🇦🇫",
    "flag_unicode": "U+1F1E6 U+1F1EB"
  },
  "AG": {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG",
    "latitude": 17.05,
    "longitude": -61.8,
    "currency": "XCD",
    "flag": "🇦🇬",
    "flag_unicode": "U+1F1E6 U+1F1EC"
  },
  "AI": {
    "name": "Anguilla",
    "dial_code": "+1 264",
    "code": "AI",
    "latitude": 18.25,
    "longitude": -63.1667,
    "currency": "XCD",
    "flag": "🇦🇮",
    "flag_unicode": "U+1F1E6 U+1F1EE"
  },
  "AL": {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL",
    "latitude": 41,
    "longitude": 20,
    "currency": "ALL",
    "flag": "🇦🇱",
    "flag_unicode": "U+1F1E6 U+1F1F1"
  },
  "AM": {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM",
    "latitude": 40,
    "longitude": 45,
    "currency": "AMD",
    "flag": "🇦🇲",
    "flag_unicode": "U+1F1E6 U+1F1F2"
  },
  "AO": {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO",
    "latitude": -12.5,
    "longitude": 18.5,
    "currency": "AOA",
    "flag": "🇦🇴",
    "flag_unicode": "U+1F1E6 U+1F1F4"
  },
  "AR": {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR",
    "latitude": -34,
    "longitude": -64,
    "currency": "ARS",
    "flag": "🇦🇷",
    "flag_unicode": "U+1F1E6 U+1F1F7"
  },
  "AS": {
    "name": "AmericanSamoa",
    "dial_code": "+1 684",
    "code": "AS",
    "latitude": -14.3333,
    "longitude": -170,
    "currency": "USD",
    "flag": "🇦🇸",
    "flag_unicode": "U+1F1E6 U+1F1F8"
  },
  "AT": {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT",
    "latitude": 47.3333,
    "longitude": 13.3333,
    "currency": "EUR",
    "flag": "🇦🇹",
    "flag_unicode": "U+1F1E6 U+1F1F9"
  },
  "AU": {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU",
    "latitude": -27,
    "longitude": 133,
    "currency": "AUD",
    "flag": "🇦🇺",
    "flag_unicode": "U+1F1E6 U+1F1FA"
  },
  "AW": {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW",
    "latitude": 12.5,
    "longitude": -69.9667,
    "currency": "AWG",
    "flag": "🇦🇼",
    "flag_unicode": "U+1F1E6 U+1F1FC"
  },
  "AX": {
    "name": "Land Islands",
    "dial_code": "+358",
    "code": "AX",
    "currency": "EUR",
    "flag": "🇦🇽",
    "flag_unicode": "U+1F1E6 U+1F1FD"
  },
  "AZ": {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ",
    "latitude": 40.5,
    "longitude": 47.5,
    "currency": "AZN",
    "flag": "🇦🇿",
    "flag_unicode": "U+1F1E6 U+1F1FF"
  },
  "BA": {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA",
    "latitude": 44,
    "longitude": 18,
    "currency": "BAM",
    "flag": "🇧🇦",
    "flag_unicode": "U+1F1E7 U+1F1E6"
  },
  "BB": {
    "name": "Barbados",
    "dial_code": "+1 246",
    "code": "BB",
    "latitude": 13.1667,
    "longitude": -59.5333,
    "currency": "BBD",
    "flag": "🇧🇧",
    "flag_unicode": "U+1F1E7 U+1F1E7"
  },
  "BD": {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD",
    "latitude": 24,
    "longitude": 90,
    "currency": "BDT",
    "flag": "🇧🇩",
    "flag_unicode": "U+1F1E7 U+1F1E9"
  },
  "BE": {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE",
    "latitude": 50.8333,
    "longitude": 4,
    "currency": "EUR",
    "flag": "🇧🇪",
    "flag_unicode": "U+1F1E7 U+1F1EA"
  },
  "BF": {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF",
    "latitude": 13,
    "longitude": -2,
    "currency": "XOF",
    "flag": "🇧🇫",
    "flag_unicode": "U+1F1E7 U+1F1EB"
  },
  "BG": {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG",
    "latitude": 43,
    "longitude": 25,
    "currency": "BGN",
    "flag": "🇧🇬",
    "flag_unicode": "U+1F1E7 U+1F1EC"
  },
  "BH": {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH",
    "latitude": 26,
    "longitude": 50.55,
    "currency": "BHD",
    "flag": "🇧🇭",
    "flag_unicode": "U+1F1E7 U+1F1ED"
  },
  "BI": {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI",
    "latitude": -3.5,
    "longitude": 30,
    "currency": "BIF",
    "flag": "🇧🇮",
    "flag_unicode": "U+1F1E7 U+1F1EE"
  },
  "BJ": {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ",
    "latitude": 9.5,
    "longitude": 2.25,
    "currency": "XOF",
    "flag": "🇧🇯",
    "flag_unicode": "U+1F1E7 U+1F1EF"
  },
  "BL": {
    "name": "Saint Barthélemy",
    "dial_code": "+590",
    "code": "BL",
    "currency": "EUR",
    "flag": "🇧🇱",
    "flag_unicode": "U+1F1E7 U+1F1F1"
  },
  "BM": {
    "name": "Bermuda",
    "dial_code": "+1 441",
    "code": "BM",
    "latitude": 32.3333,
    "longitude": -64.75,
    "currency": "BMD",
    "flag": "🇧🇲",
    "flag_unicode": "U+1F1E7 U+1F1F2"
  },
  "BN": {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN",
    "latitude": 4.5,
    "longitude": 114.6667,
    "currency": "BND",
    "flag": "🇧🇳",
    "flag_unicode": "U+1F1E7 U+1F1F3"
  },
  "BO": {
    "name": "Bolivia, Plurinational State of Bolivia",
    "dial_code": "+591",
    "code": "BO",
    "latitude": -17,
    "longitude": -65,
    "currency": "BOB",
    "flag": "🇧🇴",
    "flag_unicode": "U+1F1E7 U+1F1F4"
  },
  "BV": {
    "name": "Bouvet Island",
    "dial_code": "+55",
    "code": "BV",
    "latitude": -54.4333,
    "longitude": 3.4,
    "currency": "NOK",
    "flag": "🇧🇻",
    "flag_unicode": "U+1F1E7 U+1F1FB"
  },
  "BR": {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR",
    "latitude": -10,
    "longitude": -55,
    "currency": "BRL",
    "flag": "🇧🇷",
    "flag_unicode": "U+1F1E7 U+1F1F7"
  },
  "BS": {
    "name": "Bahamas",
    "dial_code": "+1 242",
    "code": "BS",
    "latitude": 24.25,
    "longitude": -76,
    "currency": "BSD",
    "flag": "🇧🇸",
    "flag_unicode": "U+1F1E7 U+1F1F8"
  },
  "BT": {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT",
    "latitude": 27.5,
    "longitude": 90.5,
    "currency": "BTN",
    "flag": "🇧🇹",
    "flag_unicode": "U+1F1E7 U+1F1F9"
  },
  "BW": {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW",
    "latitude": -22,
    "longitude": 24,
    "currency": "BWP",
    "flag": "🇧🇼",
    "flag_unicode": "U+1F1E7 U+1F1FC"
  },
  "BY": {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY",
    "latitude": 53,
    "longitude": 28,
    "currency": "BYR",
    "flag": "🇧🇾",
    "flag_unicode": "U+1F1E7 U+1F1FE"
  },
  "BZ": {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ",
    "latitude": 17.25,
    "longitude": -88.75,
    "currency": "BZD",
    "flag": "🇧🇿",
    "flag_unicode": "U+1F1E7 U+1F1FF"
  },
  "CA": {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA",
    "latitude": 60,
    "longitude": -95,
    "currency": "CAD",
    "flag": "🇨🇦",
    "flag_unicode": "U+1F1E8 U+1F1E6"
  },
  "CC": {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC",
    "latitude": -12.5,
    "longitude": 96.8333,
    "currency": "AUD",
    "flag": "🇨🇨",
    "flag_unicode": "U+1F1E8 U+1F1E8"
  },
  "CD": {
    "name": "Congo, The Democratic Republic of the",
    "dial_code": "+243",
    "code": "CD",
    "latitude": 0,
    "longitude": 25,
    "currency": "CDF",
    "flag": "🇨🇩",
    "flag_unicode": "U+1F1E8 U+1F1E9"
  },
  "CF": {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF",
    "latitude": 7,
    "longitude": 21,
    "currency": "XAF",
    "flag": "🇨🇫",
    "flag_unicode": "U+1F1E8 U+1F1EB"
  },
  "CG": {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG",
    "latitude": -1,
    "longitude": 15,
    "currency": "XAF",
    "flag": "🇨🇬",
    "flag_unicode": "U+1F1E8 U+1F1EC"
  },
  "CH": {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH",
    "latitude": 47,
    "longitude": 8,
    "currency": "CHF",
    "flag": "🇨🇭",
    "flag_unicode": "U+1F1E8 U+1F1ED"
  },
  "CI": {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI",
    "latitude": 8,
    "longitude": -5,
    "currency": "XOF",
    "flag": "🇨🇮",
    "flag_unicode": "U+1F1E8 U+1F1EE"
  },
  "CK": {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK",
    "latitude": -21.2333,
    "longitude": -159.7667,
    "currency": "NZD",
    "flag": "🇨🇰",
    "flag_unicode": "U+1F1E8 U+1F1F0"
  },
  "CL": {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL",
    "latitude": -30,
    "longitude": -71,
    "currency": "CLP",
    "flag": "🇨🇱",
    "flag_unicode": "U+1F1E8 U+1F1F1"
  },
  "CM": {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM",
    "latitude": 6,
    "longitude": 12,
    "currency": "XAF",
    "flag": "🇨🇲",
    "flag_unicode": "U+1F1E8 U+1F1F2"
  },
  "CN": {
    "name": "China",
    "dial_code": "+86",
    "code": "CN",
    "latitude": 35,
    "longitude": 105,
    "currency": "CNY",
    "flag": "🇨🇳",
    "flag_unicode": "U+1F1E8 U+1F1F3"
  },
  "CO": {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO",
    "latitude": 4,
    "longitude": -72,
    "currency": "COP",
    "flag": "🇨🇴",
    "flag_unicode": "U+1F1E8 U+1F1F4"
  },
  "CR": {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR",
    "latitude": 10,
    "longitude": -84,
    "currency": "CRC",
    "flag": "🇨🇷",
    "flag_unicode": "U+1F1E8 U+1F1F7"
  },
  "CU": {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU",
    "latitude": 21.5,
    "longitude": -80,
    "currency": "CUP",
    "flag": "🇨🇺",
    "flag_unicode": "U+1F1E8 U+1F1FA"
  },
  "CV": {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV",
    "latitude": 16,
    "longitude": -24,
    "currency": "CVE",
    "flag": "🇨🇻",
    "flag_unicode": "U+1F1E8 U+1F1FB"
  },
  "CW": {
    "name": "Curaçao",
    "dial_code": "+5999",
    "code": "CW",
    "currency": "ANG",
    "flag": "🇨🇼",
    "flag_unicode": "U+1F1E8 U+1F1FC"
  },
  "CX": {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX",
    "latitude": -10.5,
    "longitude": 105.6667,
    "currency": "AUD",
    "flag": "🇨🇽",
    "flag_unicode": "U+1F1E8 U+1F1FD"
  },
  "CY": {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY",
    "latitude": 35,
    "longitude": 33,
    "currency": "EUR",
    "flag": "🇨🇾",
    "flag_unicode": "U+1F1E8 U+1F1FE"
  },
  "CZ": {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ",
    "latitude": 49.75,
    "longitude": 15.5,
    "currency": "CZK",
    "flag": "🇨🇿",
    "flag_unicode": "U+1F1E8 U+1F1FF"
  },
  "DE": {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE",
    "latitude": 51,
    "longitude": 9,
    "currency": "EUR",
    "flag": "🇩🇪",
    "flag_unicode": "U+1F1E9 U+1F1EA"
  },
  "DJ": {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ",
    "latitude": 11.5,
    "longitude": 43,
    "currency": "DJF",
    "flag": "🇩🇯",
    "flag_unicode": "U+1F1E9 U+1F1EF"
  },
  "DK": {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK",
    "latitude": 56,
    "longitude": 10,
    "currency": "DKK",
    "flag": "🇩🇰",
    "flag_unicode": "U+1F1E9 U+1F1F0"
  },
  "DM": {
    "name": "Dominica",
    "dial_code": "+1 767",
    "code": "DM",
    "latitude": 15.4167,
    "longitude": -61.3333,
    "currency": "XCD",
    "flag": "🇩🇲",
    "flag_unicode": "U+1F1E9 U+1F1F2"
  },
  "DO": {
    "name": "Dominican Republic",
    "dial_code": "+1 849",
    "code": "DO",
    "latitude": 19,
    "longitude": -70.6667,
    "currency": "DOP",
    "flag": "🇩🇴",
    "flag_unicode": "U+1F1E9 U+1F1F4"
  },
  "DZ": {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ",
    "latitude": 28,
    "longitude": 3,
    "currency": "DZD",
    "flag": "🇩🇿",
    "flag_unicode": "U+1F1E9 U+1F1FF"
  },
  "EC": {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC",
    "latitude": -2,
    "longitude": -77.5,
    "currency": "USD",
    "flag": "🇪🇨",
    "flag_unicode": "U+1F1EA U+1F1E8"
  },
  "EE": {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE",
    "latitude": 59,
    "longitude": 26,
    "currency": "EUR",
    "flag": "🇪🇪",
    "flag_unicode": "U+1F1EA U+1F1EA"
  },
  "EG": {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG",
    "latitude": 27,
    "longitude": 30,
    "currency": "EGP",
    "flag": "🇪🇬",
    "flag_unicode": "U+1F1EA U+1F1EC"
  },
  "EH": {
    "name": "Western Sahara",
    "dial_code": "+732",
    "code": "EH",
    "latitude": 24.5,
    "longitude": -13,
    "currency": "MAD",
    "flag": "🇪🇭",
    "flag_unicode": "U+1F1EA U+1F1ED"
  },
  "ER": {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER",
    "latitude": 15,
    "longitude": 39,
    "currency": "ERN",
    "flag": "🇪🇷",
    "flag_unicode": "U+1F1EA U+1F1F7"
  },
  "ES": {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES",
    "latitude": 40,
    "longitude": -4,
    "currency": "EUR",
    "flag": "🇪🇸",
    "flag_unicode": "U+1F1EA U+1F1F8"
  },
  "ET": {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET",
    "latitude": 8,
    "longitude": 38,
    "currency": "ETB",
    "flag": "🇪🇹",
    "flag_unicode": "U+1F1EA U+1F1F9"
  },
  "FI": {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI",
    "latitude": 64,
    "longitude": 26,
    "currency": "EUR",
    "flag": "🇫🇮",
    "flag_unicode": "U+1F1EB U+1F1EE"
  },
  "FJ": {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ",
    "latitude": -18,
    "longitude": 175,
    "currency": "FJD",
    "flag": "🇫🇯",
    "flag_unicode": "U+1F1EB U+1F1EF"
  },
  "FK": {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK",
    "latitude": -51.75,
    "longitude": -59,
    "currency": "FKP",
    "flag": "🇫🇰",
    "flag_unicode": "U+1F1EB U+1F1F0"
  },
  "FM": {
    "name": "Micronesia, Federated States of",
    "dial_code": "+691",
    "code": "FM",
    "latitude": 6.9167,
    "longitude": 158.25,
    "currency": "USD",
    "flag": "🇫🇲",
    "flag_unicode": "U+1F1EB U+1F1F2"
  },
  "FO": {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO",
    "latitude": 62,
    "longitude": -7,
    "currency": "DKK",
    "flag": "🇫🇴",
    "flag_unicode": "U+1F1EB U+1F1F4"
  },
  "FR": {
    "name": "France",
    "dial_code": "+33",
    "code": "FR",
    "latitude": 46,
    "longitude": 2,
    "currency": "EUR",
    "flag": "🇫🇷",
    "flag_unicode": "U+1F1EB U+1F1F7"
  },
  "GA": {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA",
    "latitude": -1,
    "longitude": 11.75,
    "currency": "XAF",
    "flag": "🇬🇦",
    "flag_unicode": "U+1F1EC U+1F1E6"
  },
  "GB": {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB",
    "latitude": 54,
    "longitude": -2,
    "currency": "GBP",
    "flag": "🇬🇧",
    "flag_unicode": "U+1F1EC U+1F1E7"
  },
  "GD": {
    "name": "Grenada",
    "dial_code": "+1 473",
    "code": "GD",
    "latitude": 12.1167,
    "longitude": -61.6667,
    "currency": "XCD",
    "flag": "🇬🇩",
    "flag_unicode": "U+1F1EC U+1F1E9"
  },
  "GE": {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE",
    "latitude": 42,
    "longitude": 43.5,
    "currency": "GEL",
    "flag": "🇬🇪",
    "flag_unicode": "U+1F1EC U+1F1EA"
  },
  "GF": {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF",
    "latitude": 4,
    "longitude": -53,
    "currency": "EUR",
    "flag": "🇬🇫",
    "flag_unicode": "U+1F1EC U+1F1EB"
  },
  "GG": {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG",
    "latitude": 49.5,
    "longitude": -2.56,
    "currency": "GBP",
    "flag": "🇬🇬",
    "flag_unicode": "U+1F1EC U+1F1EC"
  },
  "GH": {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH",
    "latitude": 8,
    "longitude": -2,
    "currency": "GHS",
    "flag": "🇬🇭",
    "flag_unicode": "U+1F1EC U+1F1ED"
  },
  "GI": {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI",
    "latitude": 36.1833,
    "longitude": -5.3667,
    "currency": "GIP",
    "flag": "🇬🇮",
    "flag_unicode": "U+1F1EC U+1F1EE"
  },
  "GL": {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL",
    "latitude": 72,
    "longitude": -40,
    "currency": "DKK",
    "flag": "🇬🇱",
    "flag_unicode": "U+1F1EC U+1F1F1"
  },
  "GM": {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM",
    "latitude": 13.4667,
    "longitude": -16.5667,
    "currency": "GMD",
    "flag": "🇬🇲",
    "flag_unicode": "U+1F1EC U+1F1F2"
  },
  "GN": {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN",
    "latitude": 11,
    "longitude": -10,
    "currency": "GNF",
    "flag": "🇬🇳",
    "flag_unicode": "U+1F1EC U+1F1F3"
  },
  "GP": {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP",
    "latitude": 16.25,
    "longitude": -61.5833,
    "currency": "EUR",
    "flag": "🇬🇵",
    "flag_unicode": "U+1F1EC U+1F1F5"
  },
  "GQ": {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ",
    "latitude": 2,
    "longitude": 10,
    "currency": "XAF",
    "flag": "🇬🇶",
    "flag_unicode": "U+1F1EC U+1F1F6"
  },
  "GR": {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR",
    "latitude": 39,
    "longitude": 22,
    "currency": "EUR",
    "flag": "🇬🇷",
    "flag_unicode": "U+1F1EC U+1F1F7"
  },
  "GS": {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS",
    "latitude": -54.5,
    "longitude": -37,
    "currency": "GBP",
    "flag": "🇬🇸",
    "flag_unicode": "U+1F1EC U+1F1F8"
  },
  "GT": {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT",
    "latitude": 15.5,
    "longitude": -90.25,
    "currency": "GTQ",
    "flag": "🇬🇹",
    "flag_unicode": "U+1F1EC U+1F1F9"
  },
  "GU": {
    "name": "Guam",
    "dial_code": "+1 671",
    "code": "GU",
    "latitude": 13.4667,
    "longitude": 144.7833,
    "currency": "USD",
    "flag": "🇬🇺",
    "flag_unicode": "U+1F1EC U+1F1FA"
  },
  "GW": {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW",
    "latitude": 12,
    "longitude": -15,
    "currency": "XOF",
    "flag": "🇬🇼",
    "flag_unicode": "U+1F1EC U+1F1FC"
  },
  "GY": {
    "name": "Guyana",
    "dial_code": "+592",
    "code": "GY",
    "latitude": 5,
    "longitude": -59,
    "currency": "GYD",
    "flag": "🇬🇾",
    "flag_unicode": "U+1F1EC U+1F1FE"
  },
  "HK": {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK",
    "latitude": 22.25,
    "longitude": 114.1667,
    "currency": "HKD",
    "flag": "🇭🇰",
    "flag_unicode": "U+1F1ED U+1F1F0"
  },
  "HM": {
    "name": "Heard Island and McDonald Islands",
    "dial_code": "+672",
    "code": "HM",
    "latitude": -53.1,
    "longitude": 72.5167,
    "currency": "AUD",
    "flag": "🇭🇲",
    "flag_unicode": "U+1F1ED U+1F1F2"
  },
  "HN": {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN",
    "latitude": 15,
    "longitude": -86.5,
    "currency": "HNL",
    "flag": "🇭🇳",
    "flag_unicode": "U+1F1ED U+1F1F3"
  },
  "HR": {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR",
    "latitude": 45.1667,
    "longitude": 15.5,
    "currency": "HRK",
    "flag": "🇭🇷",
    "flag_unicode": "U+1F1ED U+1F1F7"
  },
  "HT": {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT",
    "latitude": 19,
    "longitude": -72.4167,
    "currency": "HTG",
    "flag": "🇭🇹",
    "flag_unicode": "U+1F1ED U+1F1F9"
  },
  "HU": {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU",
    "latitude": 47,
    "longitude": 20,
    "currency": "HUF",
    "flag": "🇭🇺",
    "flag_unicode": "U+1F1ED U+1F1FA"
  },
  "ID": {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID",
    "latitude": -5,
    "longitude": 120,
    "currency": "IDR",
    "flag": "🇮🇩",
    "flag_unicode": "U+1F1EE U+1F1E9"
  },
  "IE": {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE",
    "latitude": 53,
    "longitude": -8,
    "currency": "EUR",
    "flag": "🇮🇪",
    "flag_unicode": "U+1F1EE U+1F1EA"
  },
  "IL": {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL",
    "latitude": 31.5,
    "longitude": 34.75,
    "currency": "ILS",
    "flag": "🇮🇱",
    "flag_unicode": "U+1F1EE U+1F1F1"
  },
  "IM": {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM",
    "latitude": 54.23,
    "longitude": -4.55,
    "currency": "GBP",
    "flag": "🇮🇲",
    "flag_unicode": "U+1F1EE U+1F1F2"
  },
  "IN": {
    "name": "India",
    "dial_code": "+91",
    "code": "IN",
    "latitude": 20,
    "longitude": 77,
    "currency": "INR",
    "flag": "🇮🇳",
    "flag_unicode": "U+1F1EE U+1F1F3"
  },
  "IO": {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO",
    "latitude": -6,
    "longitude": 71.5,
    "currency": "USD",
    "flag": "🇮🇴",
    "flag_unicode": "U+1F1EE U+1F1F4"
  },
  "IQ": {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ",
    "latitude": 33,
    "longitude": 44,
    "currency": "IQD",
    "flag": "🇮🇶",
    "flag_unicode": "U+1F1EE U+1F1F6"
  },
  "IR": {
    "name": "Iran, Islamic Republic of",
    "dial_code": "+98",
    "code": "IR",
    "latitude": 32,
    "longitude": 53,
    "currency": "IRR",
    "flag": "🇮🇷",
    "flag_unicode": "U+1F1EE U+1F1F7"
  },
  "IS": {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS",
    "latitude": 65,
    "longitude": -18,
    "currency": "ISK",
    "flag": "🇮🇸",
    "flag_unicode": "U+1F1EE U+1F1F8"
  },
  "IT": {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT",
    "latitude": 42.8333,
    "longitude": 12.8333,
    "currency": "EUR",
    "flag": "🇮🇹",
    "flag_unicode": "U+1F1EE U+1F1F9"
  },
  "JE": {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE",
    "latitude": 49.21,
    "longitude": -2.13,
    "currency": "GBP",
    "flag": "🇯🇪",
    "flag_unicode": "U+1F1EF U+1F1EA"
  },
  "JM": {
    "name": "Jamaica",
    "dial_code": "+1 876",
    "code": "JM",
    "latitude": 18.25,
    "longitude": -77.5,
    "currency": "JMD",
    "flag": "🇯🇲",
    "flag_unicode": "U+1F1EF U+1F1F2"
  },
  "JO": {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO",
    "latitude": 31,
    "longitude": 36,
    "currency": "JOD",
    "flag": "🇯🇴",
    "flag_unicode": "U+1F1EF U+1F1F4"
  },
  "JP": {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP",
    "latitude": 36,
    "longitude": 138,
    "currency": "JPY",
    "flag": "🇯🇵",
    "flag_unicode": "U+1F1EF U+1F1F5"
  },
  "KE": {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE",
    "latitude": 1,
    "longitude": 38,
    "currency": "KES",
    "flag": "🇰🇪",
    "flag_unicode": "U+1F1F0 U+1F1EA"
  },
  "KG": {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG",
    "latitude": 41,
    "longitude": 75,
    "currency": "KGS",
    "flag": "🇰🇬",
    "flag_unicode": "U+1F1F0 U+1F1EC"
  },
  "KH": {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH",
    "latitude": 13,
    "longitude": 105,
    "currency": "KHR",
    "flag": "🇰🇭",
    "flag_unicode": "U+1F1F0 U+1F1ED"
  },
  "KI": {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI",
    "latitude": 1.4167,
    "longitude": 173,
    "currency": "AUD",
    "flag": "🇰🇮",
    "flag_unicode": "U+1F1F0 U+1F1EE"
  },
  "KM": {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM",
    "latitude": -12.1667,
    "longitude": 44.25,
    "currency": "KMF",
    "flag": "🇰🇲",
    "flag_unicode": "U+1F1F0 U+1F1F2"
  },
  "KN": {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1 869",
    "code": "KN",
    "latitude": 17.3333,
    "longitude": -62.75,
    "currency": "XCD",
    "flag": "🇰🇳",
    "flag_unicode": "U+1F1F0 U+1F1F3"
  },
  "KP": {
    "name": "Korea, Democratic People's Republic of",
    "dial_code": "+850",
    "code": "KP",
    "latitude": 40,
    "longitude": 127,
    "currency": "KPW",
    "flag": "🇰🇵",
    "flag_unicode": "U+1F1F0 U+1F1F5"
  },
  "KR": {
    "name": "Korea, Republic of",
    "dial_code": "+82",
    "code": "KR",
    "latitude": 37,
    "longitude": 127.5,
    "currency": "KRW",
    "flag": "🇰🇷",
    "flag_unicode": "U+1F1F0 U+1F1F7"
  },
  "KW": {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW",
    "latitude": 29.3375,
    "longitude": 47.6581,
    "currency": "KWD",
    "flag": "🇰🇼",
    "flag_unicode": "U+1F1F0 U+1F1FC"
  },
  "KY": {
    "name": "Cayman Islands",
    "dial_code": "+1345",
    "code": "KY",
    "latitude": 19.5,
    "longitude": -80.5,
    "currency": "KYD",
    "flag": "🇰🇾",
    "flag_unicode": "U+1F1F0 U+1F1FE"
  },
  "KZ": {
    "name": "Kazakhstan",
    "dial_code": "+7",
    "code": "KZ",
    "latitude": 48,
    "longitude": 68,
    "currency": "KZT",
    "flag": "🇰🇿",
    "flag_unicode": "U+1F1F0 U+1F1FF"
  },
  "LA": {
    "name": "Lao People's Democratic Republic",
    "dial_code": "+856",
    "code": "LA",
    "latitude": 18,
    "longitude": 105,
    "currency": "LAK",
    "flag": "🇱🇦",
    "flag_unicode": "U+1F1F1 U+1F1E6"
  },
  "LB": {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB",
    "latitude": 33.8333,
    "longitude": 35.8333,
    "currency": "LBP",
    "flag": "🇱🇧",
    "flag_unicode": "U+1F1F1 U+1F1E7"
  },
  "LC": {
    "name": "Saint Lucia",
    "dial_code": "+1 758",
    "code": "LC",
    "latitude": 13.8833,
    "longitude": -61.1333,
    "currency": "XCD",
    "flag": "🇱🇨",
    "flag_unicode": "U+1F1F1 U+1F1E8"
  },
  "LI": {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI",
    "latitude": 47.1667,
    "longitude": 9.5333,
    "currency": "CHF",
    "flag": "🇱🇮",
    "flag_unicode": "U+1F1F1 U+1F1EE"
  },
  "LK": {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK",
    "latitude": 7,
    "longitude": 81,
    "currency": "LKR",
    "flag": "🇱🇰",
    "flag_unicode": "U+1F1F1 U+1F1F0"
  },
  "LR": {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR",
    "latitude": 6.5,
    "longitude": -9.5,
    "currency": "LRD",
    "flag": "🇱🇷",
    "flag_unicode": "U+1F1F1 U+1F1F7"
  },
  "LS": {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS",
    "latitude": -29.5,
    "longitude": 28.5,
    "currency": "LSL",
    "flag": "🇱🇸",
    "flag_unicode": "U+1F1F1 U+1F1F8"
  },
  "LT": {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT",
    "latitude": 56,
    "longitude": 24,
    "currency": "LTL",
    "flag": "🇱🇹",
    "flag_unicode": "U+1F1F1 U+1F1F9"
  },
  "LU": {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU",
    "latitude": 49.75,
    "longitude": 6.1667,
    "currency": "EUR",
    "flag": "🇱🇺",
    "flag_unicode": "U+1F1F1 U+1F1FA"
  },
  "LV": {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV",
    "latitude": 57,
    "longitude": 25,
    "currency": "EUR",
    "flag": "🇱🇻",
    "flag_unicode": "U+1F1F1 U+1F1FB"
  },
  "LY": {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY",
    "latitude": 25,
    "longitude": 17,
    "currency": "LYD",
    "flag": "🇱🇾",
    "flag_unicode": "U+1F1F1 U+1F1FE"
  },
  "MA": {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA",
    "latitude": 32,
    "longitude": -5,
    "currency": "MAD",
    "flag": "🇲🇦",
    "flag_unicode": "U+1F1F2 U+1F1E6"
  },
  "MC": {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC",
    "latitude": 43.7333,
    "longitude": 7.4,
    "currency": "EUR",
    "flag": "🇲🇨",
    "flag_unicode": "U+1F1F2 U+1F1E8"
  },
  "MD": {
    "name": "Moldova, Republic of",
    "dial_code": "+373",
    "code": "MD",
    "latitude": 47,
    "longitude": 29,
    "currency": "MDL",
    "flag": "🇲🇩",
    "flag_unicode": "U+1F1F2 U+1F1E9"
  },
  "ME": {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME",
    "latitude": 42,
    "longitude": 19,
    "currency": "EUR",
    "flag": "🇲🇪",
    "flag_unicode": "U+1F1F2 U+1F1EA"
  },
  "MF": {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF",
    "currency": "EUR",
    "flag": "🇲🇫",
    "flag_unicode": "U+1F1F2 U+1F1EB"
  },
  "MG": {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG",
    "latitude": -20,
    "longitude": 47,
    "currency": "MGA",
    "flag": "🇲🇬",
    "flag_unicode": "U+1F1F2 U+1F1EC"
  },
  "MH": {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH",
    "latitude": 9,
    "longitude": 168,
    "currency": "USD",
    "flag": "🇲🇭",
    "flag_unicode": "U+1F1F2 U+1F1ED"
  },
  "MK": {
    "name": "Macedonia, The Former Yugoslav Republic of",
    "dial_code": "+389",
    "code": "MK",
    "latitude": 41.8333,
    "longitude": 22,
    "currency": "MKD",
    "flag": "🇲🇰",
    "flag_unicode": "U+1F1F2 U+1F1F0"
  },
  "ML": {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML",
    "latitude": 17,
    "longitude": -4,
    "currency": "XOF",
    "flag": "🇲🇱",
    "flag_unicode": "U+1F1F2 U+1F1F1"
  },
  "MM": {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM",
    "latitude": 22,
    "longitude": 98,
    "currency": "MMK",
    "flag": "🇲🇲",
    "flag_unicode": "U+1F1F2 U+1F1F2"
  },
  "MN": {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN",
    "latitude": 46,
    "longitude": 105,
    "currency": "MNT",
    "flag": "🇲🇳",
    "flag_unicode": "U+1F1F2 U+1F1F3"
  },
  "MO": {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO",
    "latitude": 22.1667,
    "longitude": 113.55,
    "currency": "MOP",
    "flag": "🇲🇴",
    "flag_unicode": "U+1F1F2 U+1F1F4"
  },
  "MP": {
    "name": "Northern Mariana Islands",
    "dial_code": "+1 670",
    "code": "MP",
    "latitude": 15.2,
    "longitude": 145.75,
    "currency": "USD",
    "flag": "🇲🇵",
    "flag_unicode": "U+1F1F2 U+1F1F5"
  },
  "MQ": {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ",
    "latitude": 14.6667,
    "longitude": -61,
    "currency": "EUR",
    "flag": "🇲🇶",
    "flag_unicode": "U+1F1F2 U+1F1F6"
  },
  "MR": {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR",
    "latitude": 20,
    "longitude": -12,
    "currency": "MRO",
    "flag": "🇲🇷",
    "flag_unicode": "U+1F1F2 U+1F1F7"
  },
  "MS": {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS",
    "latitude": 16.75,
    "longitude": -62.2,
    "currency": "XCD",
    "flag": "🇲🇸",
    "flag_unicode": "U+1F1F2 U+1F1F8"
  },
  "MT": {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT",
    "latitude": 35.8333,
    "longitude": 14.5833,
    "currency": "EUR",
    "flag": "🇲🇹",
    "flag_unicode": "U+1F1F2 U+1F1F9"
  },
  "MU": {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU",
    "latitude": -20.2833,
    "longitude": 57.55,
    "currency": "MUR",
    "flag": "🇲🇺",
    "flag_unicode": "U+1F1F2 U+1F1FA"
  },
  "MV": {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV",
    "latitude": 3.25,
    "longitude": 73,
    "currency": "MVR",
    "flag": "🇲🇻",
    "flag_unicode": "U+1F1F2 U+1F1FB"
  },
  "MW": {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW",
    "latitude": -13.5,
    "longitude": 34,
    "currency": "MWK",
    "flag": "🇲🇼",
    "flag_unicode": "U+1F1F2 U+1F1FC"
  },
  "MX": {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX",
    "latitude": 23,
    "longitude": -102,
    "currency": "MXN",
    "flag": "🇲🇽",
    "flag_unicode": "U+1F1F2 U+1F1FD"
  },
  "MY": {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY",
    "latitude": 2.5,
    "longitude": 112.5,
    "currency": "MYR",
    "flag": "🇲🇾",
    "flag_unicode": "U+1F1F2 U+1F1FE"
  },
  "MZ": {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ",
    "latitude": -18.25,
    "longitude": 35,
    "currency": "MZN",
    "flag": "🇲🇿",
    "flag_unicode": "U+1F1F2 U+1F1FF"
  },
  "NA": {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA",
    "latitude": -22,
    "longitude": 17,
    "currency": "NAD",
    "flag": "🇳🇦",
    "flag_unicode": "U+1F1F3 U+1F1E6"
  },
  "NC": {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC",
    "latitude": -21.5,
    "longitude": 165.5,
    "currency": "XPF",
    "flag": "🇳🇨",
    "flag_unicode": "U+1F1F3 U+1F1E8"
  },
  "NE": {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE",
    "latitude": 16,
    "longitude": 8,
    "currency": "XOF",
    "flag": "🇳🇪",
    "flag_unicode": "U+1F1F3 U+1F1EA"
  },
  "NF": {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF",
    "latitude": -29.0333,
    "longitude": 167.95,
    "currency": "AUD",
    "flag": "🇳🇫",
    "flag_unicode": "U+1F1F3 U+1F1EB"
  },
  "NG": {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG",
    "latitude": 10,
    "longitude": 8,
    "currency": "NGN",
    "flag": "🇳🇬",
    "flag_unicode": "U+1F1F3 U+1F1EC"
  },
  "NI": {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI",
    "latitude": 13,
    "longitude": -85,
    "currency": "NIO",
    "flag": "🇳🇮",
    "flag_unicode": "U+1F1F3 U+1F1EE"
  },
  "NL": {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL",
    "latitude": 52.5,
    "longitude": 5.75,
    "currency": "EUR",
    "flag": "🇳🇱",
    "flag_unicode": "U+1F1F3 U+1F1F1"
  },
  "NO": {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO",
    "latitude": 62,
    "longitude": 10,
    "currency": "NOK",
    "flag": "🇳🇴",
    "flag_unicode": "U+1F1F3 U+1F1F4"
  },
  "NP": {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP",
    "latitude": 28,
    "longitude": 84,
    "currency": "NPR",
    "flag": "🇳🇵",
    "flag_unicode": "U+1F1F3 U+1F1F5"
  },
  "NR": {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR",
    "latitude": -0.5333,
    "longitude": 166.9167,
    "currency": "AUD",
    "flag": "🇳🇷",
    "flag_unicode": "U+1F1F3 U+1F1F7"
  },
  "NU": {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU",
    "latitude": -19.0333,
    "longitude": -169.8667,
    "currency": "NZD",
    "flag": "🇳🇺",
    "flag_unicode": "U+1F1F3 U+1F1FA"
  },
  "NZ": {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ",
    "latitude": -41,
    "longitude": 174,
    "currency": "NZD",
    "flag": "🇳🇿",
    "flag_unicode": "U+1F1F3 U+1F1FF"
  },
  "OM": {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM",
    "latitude": 21,
    "longitude": 57,
    "currency": "OMR",
    "flag": "🇴🇲",
    "flag_unicode": "U+1F1F4 U+1F1F2"
  },
  "PA": {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA",
    "latitude": 9,
    "longitude": -80,
    "currency": "PAB",
    "flag": "🇵🇦",
    "flag_unicode": "U+1F1F5 U+1F1E6"
  },
  "PE": {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE",
    "latitude": -10,
    "longitude": -76,
    "currency": "PEN",
    "flag": "🇵🇪",
    "flag_unicode": "U+1F1F5 U+1F1EA"
  },
  "PF": {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF",
    "latitude": -15,
    "longitude": -140,
    "currency": "XPF",
    "flag": "🇵🇫",
    "flag_unicode": "U+1F1F5 U+1F1EB"
  },
  "PG": {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG",
    "latitude": -6,
    "longitude": 147,
    "currency": "PGK",
    "flag": "🇵🇬",
    "flag_unicode": "U+1F1F5 U+1F1EC"
  },
  "PH": {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH",
    "latitude": 13,
    "longitude": 122,
    "currency": "PHP",
    "flag": "🇵🇭",
    "flag_unicode": "U+1F1F5 U+1F1ED"
  },
  "PK": {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK",
    "latitude": 30,
    "longitude": 70,
    "currency": "PKR",
    "flag": "🇵🇰",
    "flag_unicode": "U+1F1F5 U+1F1F0"
  },
  "PL": {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL",
    "latitude": 52,
    "longitude": 20,
    "currency": "PLN",
    "flag": "🇵🇱",
    "flag_unicode": "U+1F1F5 U+1F1F1"
  },
  "PM": {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM",
    "latitude": 46.8333,
    "longitude": -56.3333,
    "currency": "EUR",
    "flag": "🇵🇲",
    "flag_unicode": "U+1F1F5 U+1F1F2"
  },
  "PN": {
    "name": "Pitcairn",
    "dial_code": "+870",
    "code": "PN",
    "latitude": -24.7,
    "longitude": -127.4,
    "currency": "NZD",
    "flag": "🇵🇳",
    "flag_unicode": "U+1F1F5 U+1F1F3"
  },
  "PR": {
    "name": "Puerto Rico",
    "dial_code": "+1 939",
    "code": "PR",
    "latitude": 18.25,
    "longitude": -66.5,
    "currency": "USD",
    "flag": "🇵🇷",
    "flag_unicode": "U+1F1F5 U+1F1F7"
  },
  "PS": {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS",
    "latitude": 32,
    "longitude": 35.25,
    "currency": "ILS",
    "flag": "🇵🇸",
    "flag_unicode": "U+1F1F5 U+1F1F8"
  },
  "PT": {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT",
    "latitude": 39.5,
    "longitude": -8,
    "currency": "EUR",
    "flag": "🇵🇹",
    "flag_unicode": "U+1F1F5 U+1F1F9"
  },
  "PW": {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW",
    "latitude": 7.5,
    "longitude": 134.5,
    "currency": "USD",
    "flag": "🇵🇼",
    "flag_unicode": "U+1F1F5 U+1F1FC"
  },
  "PY": {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY",
    "latitude": -23,
    "longitude": -58,
    "currency": "PYG",
    "flag": "🇵🇾",
    "flag_unicode": "U+1F1F5 U+1F1FE"
  },
  "QA": {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA",
    "latitude": 25.5,
    "longitude": 51.25,
    "currency": "QAR",
    "flag": "🇶🇦",
    "flag_unicode": "U+1F1F6 U+1F1E6"
  },
  "RE": {
    "name": "Réunion",
    "dial_code": "+262",
    "code": "RE",
    "latitude": -21.1,
    "longitude": 55.6,
    "currency": "EUR",
    "flag": "🇷🇪",
    "flag_unicode": "U+1F1F7 U+1F1EA"
  },
  "RO": {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO",
    "latitude": 46,
    "longitude": 25,
    "currency": "RON",
    "flag": "🇷🇴",
    "flag_unicode": "U+1F1F7 U+1F1F4"
  },
  "RS": {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS",
    "latitude": 44,
    "longitude": 21,
    "currency": "RSD",
    "flag": "🇷🇸",
    "flag_unicode": "U+1F1F7 U+1F1F8"
  },
  "RU": {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU",
    "latitude": 60,
    "longitude": 100,
    "currency": "RUB",
    "flag": "🇷🇺",
    "flag_unicode": "U+1F1F7 U+1F1FA"
  },
  "RW": {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW",
    "latitude": -2,
    "longitude": 30,
    "currency": "RWF",
    "flag": "🇷🇼",
    "flag_unicode": "U+1F1F7 U+1F1FC"
  },
  "SA": {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA",
    "latitude": 25,
    "longitude": 45,
    "currency": "SAR",
    "flag": "🇸🇦",
    "flag_unicode": "U+1F1F8 U+1F1E6"
  },
  "SB": {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB",
    "latitude": -8,
    "longitude": 159,
    "currency": "SBD",
    "flag": "🇸🇧",
    "flag_unicode": "U+1F1F8 U+1F1E7"
  },
  "SC": {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC",
    "latitude": -4.5833,
    "longitude": 55.6667,
    "currency": "SCR",
    "flag": "🇸🇨",
    "flag_unicode": "U+1F1F8 U+1F1E8"
  },
  "SD": {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD",
    "latitude": 15,
    "longitude": 30,
    "currency": "SDG",
    "flag": "🇸🇩",
    "flag_unicode": "U+1F1F8 U+1F1E9"
  },
  "SE": {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE",
    "latitude": 62,
    "longitude": 15,
    "currency": "SEK",
    "flag": "🇸🇪",
    "flag_unicode": "U+1F1F8 U+1F1EA"
  },
  "SG": {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG",
    "latitude": 1.3667,
    "longitude": 103.8,
    "currency": "SGD",
    "flag": "🇸🇬",
    "flag_unicode": "U+1F1F8 U+1F1EC"
  },
  "SH": {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH",
    "latitude": -15.9333,
    "longitude": -5.7,
    "currency": "SHP",
    "flag": "🇸🇭",
    "flag_unicode": "U+1F1F8 U+1F1ED"
  },
  "SI": {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI",
    "latitude": 46,
    "longitude": 15,
    "currency": "EUR",
    "flag": "🇸🇮",
    "flag_unicode": "U+1F1F8 U+1F1EE"
  },
  "SJ": {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ",
    "latitude": 78,
    "longitude": 20,
    "currency": "NOK",
    "flag": "🇸🇯",
    "flag_unicode": "U+1F1F8 U+1F1EF"
  },
  "SK": {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK",
    "latitude": 48.6667,
    "longitude": 19.5,
    "currency": "EUR",
    "flag": "🇸🇰",
    "flag_unicode": "U+1F1F8 U+1F1F0"
  },
  "SL": {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL",
    "latitude": 8.5,
    "longitude": -11.5,
    "currency": "SLL",
    "flag": "🇸🇱",
    "flag_unicode": "U+1F1F8 U+1F1F1"
  },
  "SM": {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM",
    "latitude": 43.7667,
    "longitude": 12.4167,
    "currency": "EUR",
    "flag": "🇸🇲",
    "flag_unicode": "U+1F1F8 U+1F1F2"
  },
  "SN": {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN",
    "latitude": 14,
    "longitude": -14,
    "currency": "XOF",
    "flag": "🇸🇳",
    "flag_unicode": "U+1F1F8 U+1F1F3"
  },
  "SO": {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO",
    "latitude": 10,
    "longitude": 49,
    "currency": "SOS",
    "flag": "🇸🇴",
    "flag_unicode": "U+1F1F8 U+1F1F4"
  },
  "SR": {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR",
    "latitude": 4,
    "longitude": -56,
    "currency": "SRD",
    "flag": "🇸🇷",
    "flag_unicode": "U+1F1F8 U+1F1F7"
  },
  "SS": {
    "name": "South Sudan",
    "dial_code": "+211",
    "code": "SS",
    "currency": "SSP",
    "flag": "🇸🇸",
    "flag_unicode": "U+1F1F8 U+1F1F8"
  },
  "ST": {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST",
    "latitude": 1,
    "longitude": 7,
    "currency": "STD",
    "flag": "🇸🇹",
    "flag_unicode": "U+1F1F8 U+1F1F9"
  },
  "SV": {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV",
    "latitude": 13.8333,
    "longitude": -88.9167,
    "currency": "USD",
    "flag": "🇸🇻",
    "flag_unicode": "U+1F1F8 U+1F1FB"
  },
  "SX": {
    "name": "Sint Maarten",
    "dial_code": "+1721",
    "code": "SX",
    "currency": "ANG",
    "flag": "🇸🇽",
    "flag_unicode": "U+1F1F8 U+1F1FD"
  },
  "SY": {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY",
    "latitude": 35,
    "longitude": 38,
    "currency": "SYP",
    "flag": "🇸🇾",
    "flag_unicode": "U+1F1F8 U+1F1FE"
  },
  "SZ": {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ",
    "latitude": -26.5,
    "longitude": 31.5,
    "currency": "SZL",
    "flag": "🇸🇿",
    "flag_unicode": "U+1F1F8 U+1F1FF"
  },
  "TC": {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1 649",
    "code": "TC",
    "latitude": 21.75,
    "longitude": -71.5833,
    "currency": "USD",
    "flag": "🇹🇨",
    "flag_unicode": "U+1F1F9 U+1F1E8"
  },
  "TD": {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD",
    "latitude": 15,
    "longitude": 19,
    "currency": "XAF",
    "flag": "🇹🇩",
    "flag_unicode": "U+1F1F9 U+1F1E9"
  },
  "TF": {
    "name": "French Southern and Antarctic Lands",
    "dial_code": "+262",
    "code": "TF",
    "latitude": -43,
    "longitude": 67,
    "currency": "EUR",
    "flag": "🇹🇫",
    "flag_unicode": "U+1F1F9 U+1F1EB"
  },
  "TG": {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG",
    "latitude": 8,
    "longitude": 1.1667,
    "currency": "XOF",
    "flag": "🇹🇬",
    "flag_unicode": "U+1F1F9 U+1F1EC"
  },
  "TH": {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH",
    "latitude": 15,
    "longitude": 100,
    "currency": "THB",
    "flag": "🇹🇭",
    "flag_unicode": "U+1F1F9 U+1F1ED"
  },
  "TJ": {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ",
    "latitude": 39,
    "longitude": 71,
    "currency": "TJS",
    "flag": "🇹🇯",
    "flag_unicode": "U+1F1F9 U+1F1EF"
  },
  "TK": {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK",
    "latitude": -9,
    "longitude": -172,
    "currency": "NZD",
    "flag": "🇹🇰",
    "flag_unicode": "U+1F1F9 U+1F1F0"
  },
  "TL": {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL",
    "latitude": -8.55,
    "longitude": 125.5167,
    "currency": "USD",
    "flag": "🇹🇱",
    "flag_unicode": "U+1F1F9 U+1F1F1"
  },
  "TM": {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM",
    "latitude": 40,
    "longitude": 60,
    "currency": "TMT",
    "flag": "🇹🇲",
    "flag_unicode": "U+1F1F9 U+1F1F2"
  },
  "TN": {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN",
    "latitude": 34,
    "longitude": 9,
    "currency": "TND",
    "flag": "🇹🇳",
    "flag_unicode": "U+1F1F9 U+1F1F3"
  },
  "TO": {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO",
    "latitude": -20,
    "longitude": -175,
    "currency": "TOP",
    "flag": "🇹🇴",
    "flag_unicode": "U+1F1F9 U+1F1F4"
  },
  "TR": {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR",
    "latitude": 39,
    "longitude": 35,
    "currency": "TRY",
    "flag": "🇹🇷",
    "flag_unicode": "U+1F1F9 U+1F1F7"
  },
  "TT": {
    "name": "Trinidad and Tobago",
    "dial_code": "+1 868",
    "code": "TT",
    "latitude": 11,
    "longitude": -61,
    "currency": "TTD",
    "flag": "🇹🇹",
    "flag_unicode": "U+1F1F9 U+1F1F9"
  },
  "TV": {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV",
    "latitude": -8,
    "longitude": 178,
    "currency": "AUD",
    "flag": "🇹🇻",
    "flag_unicode": "U+1F1F9 U+1F1FB"
  },
  "TW": {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW",
    "latitude": 23.5,
    "longitude": 121,
    "currency": "TWD",
    "flag": "🇹🇼",
    "flag_unicode": "U+1F1F9 U+1F1FC"
  },
  "TZ": {
    "name": "Tanzania, United Republic of",
    "dial_code": "+255",
    "code": "TZ",
    "latitude": -6,
    "longitude": 35,
    "currency": "TZS",
    "flag": "🇹🇿",
    "flag_unicode": "U+1F1F9 U+1F1FF"
  },
  "UA": {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA",
    "latitude": 49,
    "longitude": 32,
    "currency": "UAH",
    "flag": "🇺🇦",
    "flag_unicode": "U+1F1FA U+1F1E6"
  },
  "UG": {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG",
    "latitude": 1,
    "longitude": 32,
    "currency": "UGX",
    "flag": "🇺🇬",
    "flag_unicode": "U+1F1FA U+1F1EC"
  },
  "UM": {
    "name": "United States Minor Outlying Islands",
    "dial_code": "+1581",
    "code": "UM",
    "latitude": 19.2833,
    "longitude": 166.6,
    "currency": "USD",
    "flag": "🇺🇲",
    "flag_unicode": "U+1F1FA U+1F1F2"
  },
  "US": {
    "name": "United States",
    "dial_code": "+1",
    "code": "US",
    "latitude": 38,
    "longitude": -97,
    "currency": "USD",
    "flag": "🇺🇸",
    "flag_unicode": "U+1F1FA U+1F1F8"
  },
  "UY": {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY",
    "latitude": -33,
    "longitude": -56,
    "currency": "UYU",
    "flag": "🇺🇾",
    "flag_unicode": "U+1F1FA U+1F1FE"
  },
  "UZ": {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ",
    "latitude": 41,
    "longitude": 64,
    "currency": "UZS",
    "flag": "🇺🇿",
    "flag_unicode": "U+1F1FA U+1F1FF"
  },
  "VA": {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA",
    "latitude": 41.9,
    "longitude": 12.45,
    "currency": "EUR",
    "flag": "🇻🇦",
    "flag_unicode": "U+1F1FB U+1F1E6"
  },
  "VC": {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1 784",
    "code": "VC",
    "latitude": 13.25,
    "longitude": -61.2,
    "currency": "XCD",
    "flag": "🇻🇨",
    "flag_unicode": "U+1F1FB U+1F1E8"
  },
  "VE": {
    "name": "Venezuela, Bolivarian Republic of",
    "dial_code": "+58",
    "code": "VE",
    "latitude": 8,
    "longitude": -66,
    "currency": "VEF",
    "flag": "🇻🇪",
    "flag_unicode": "U+1F1FB U+1F1EA"
  },
  "VG": {
    "name": "Virgin Islands, British",
    "dial_code": "+1 284",
    "code": "VG",
    "latitude": 18.5,
    "longitude": -64.5,
    "currency": "USD",
    "flag": "🇻🇬",
    "flag_unicode": "U+1F1FB U+1F1EC"
  },
  "VI": {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1 340",
    "code": "VI",
    "latitude": 18.3333,
    "longitude": -64.8333,
    "currency": "USD",
    "flag": "🇻🇮",
    "flag_unicode": "U+1F1FB U+1F1EE"
  },
  "VN": {
    "name": "Viet Nam",
    "dial_code": "+84",
    "code": "VN",
    "latitude": 16,
    "longitude": 106,
    "currency": "VND",
    "flag": "🇻🇳",
    "flag_unicode": "U+1F1FB U+1F1F3"
  },
  "VU": {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU",
    "latitude": -16,
    "longitude": 167,
    "currency": "VUV",
    "flag": "🇻🇺",
    "flag_unicode": "U+1F1FB U+1F1FA"
  },
  "WF": {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF",
    "latitude": -13.3,
    "longitude": -176.2,
    "currency": "XPF",
    "flag": "🇼🇫",
    "flag_unicode": "U+1F1FC U+1F1EB"
  },
  "WS": {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS",
    "latitude": -13.5833,
    "longitude": -172.3333,
    "currency": "WST",
    "flag": "🇼🇸",
    "flag_unicode": "U+1F1FC U+1F1F8"
  },
  "XK": {
    "name": "Kosovo, Republic of Kosovo",
    "dial_code": "+383",
    "code": "XK",
    "currency": "EUR",
    "flag": "🇽🇰",
    "flag_unicode": "U+1F1FD U+1F1F0"
  },
  "YE": {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE",
    "latitude": 15,
    "longitude": 48,
    "currency": "YER",
    "flag": "🇾🇪",
    "flag_unicode": "U+1F1FE U+1F1EA"
  },
  "YT": {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT",
    "latitude": -12.8333,
    "longitude": 45.1667,
    "currency": "EUR",
    "flag": "🇾🇹",
    "flag_unicode": "U+1F1FE U+1F1F9"
  },
  "ZA": {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA",
    "latitude": -29,
    "longitude": 24,
    "currency": "ZAR",
    "flag": "🇿🇦",
    "flag_unicode": "U+1F1FF U+1F1E6"
  },
  "ZM": {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM",
    "latitude": -15,
    "longitude": 30,
    "currency": "ZMK",
    "flag": "🇿🇲",
    "flag_unicode": "U+1F1FF U+1F1F2"
  },
  "ZW": {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW",
    "latitude": -20,
    "longitude": 30,
    "currency": "ZWL",
    "flag": "🇿🇼",
    "flag_unicode": "U+1F1FF U+1F1FC"
  }
}
